import { NgModule } from '@angular/core';
import { CONFIG_MANAGER_SERVICE_CONFIGURATION, ConfigManagerModule } from '@xpo-ltl/config-manager';
import {HumanResourceApiService} from './humanresource-api.service';

@NgModule({
  imports: [
    ConfigManagerModule
  ],
  providers: [
    HumanResourceApiService,
    { provide: CONFIG_MANAGER_SERVICE_CONFIGURATION, useValue: { configFileUrl: './assets/config.json'}},
  ]
})
export class SdkHumanResourceModule { }
